import * as WebFont from 'webfontloader';
import './react';
import './bootstrap';
import './trackers';
import './google-maps-api';
import './scroll-icon';
import './custom';
import './install-button';

export function loadGoogleFont(fonts: Array<string>) {
    WebFont.load({
        google: {
            families: fonts,
        },
    });
}
